import { useParams, Link } from "react-router-dom";
import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import door from "../assets/door.webp";
import uni from "../assets/services/University selection.webp";
import test from "../assets/services/Test Preparation.webp";
import appli from "../assets/services/Application Assistance.webp";
import visa from "../assets/services/Visa Guidance.webp";
import fin from "../assets/services/Financial Assistance.webp";
import pre from "../assets/services/Pre-Departure Assistance.png";
import acco from "../assets/services/Accommodation Assistance.webp";
import post from "../assets/services/Post-Arrival Assistance.png";
import door1 from "../assets/services/content/Door-to-Door Counselling.webp";
import uni1 from "../assets/services/content/University Selection (1).webp";
import test1 from "../assets/services/content/Test Preparation (1).webp";
import appli1 from "../assets/services/content/Application Assistance (1).webp";
import visa1 from "../assets/services/content/Visa Guidance (1).webp";
import fin1 from "../assets/services/content/Financial Assistance (1).webp";
import pre1 from "../assets/services/content/Pre-Departure Assistance (1).webp";
import acco1 from "../assets/services/content/Accommodation Assistance (1).webp";
import post1 from "../assets/services/content/Post-Arrival Assistance (1).webp";


/* ================= DATA ================= */

const serviceData = {
  "door-to-door-counselling": {
    title: "Door-to-Door Counselling",
    heroImage: door,
    contentImage: door1,
    description: "Our Door-to-Door Counselling service provides personalized overseas education guidance directly at your home. We offer private one-on-one consultations that help students and parents understand study abroad opportunities, course suitability, financial planning, and visa pathways. This service focuses on clear decision-making, long-term career planning, and trusted expert recommendations to ensure a confident and successful international education journey.",
     points: [
      {
        title: "Private Home Consultation",
        desc: "Personalized overseas education counselling delivered at your doorstep for maximum comfort and privacy."
      },
      {
        title: "Student Profile Evaluation",
        desc: "We assess academic performance, career interests, and study abroad eligibility."
      },
      {
        title: "Country & Course Planning",
        desc: "Expert recommendations for the best universities, courses, and countries."
      },
      {
        title: "Financial & Visa Roadmap",
        desc: "Strategic planning for tuition budgeting, loans, scholarships, and visa preparation."
      },
      {
        title: "Customized Success Strategy",
        desc: "A tailored roadmap designed to ensure admission success and long-term career growth."
      }
    ]
  },

  "university-selection": {
    title: "University Selection",
    heroImage: uni,
    contentImage: uni1,
    description: "Our University Selection service helps students shortlist the best universities based on academic profile, global rankings, tuition affordability, faculty reputation, and career outcomes. We evaluate admission probability, return on investment, employment opportunities, and course quality to recommend institutions that align with long-term student success.",
    points: [
  {
    title: "Academic Profile Assessment",
    desc: "We analyze grades, test scores, achievements, and academic strengths."
  },
  {
    title: "University & Course Shortlisting",
    desc: "Data-driven selection of top-ranked universities matching your profile."
  },
  {
    title: "Admission Probability Evaluation",
    desc: "We assess acceptance chances based on previous admission trends."
  },
  {
    title: "Cost & ROI Comparison",
    desc: "Compare tuition, scholarships, living costs, and career return on investment."
  },
  {
    title: "Final University Recommendation",
    desc: "Receive a strategic shortlist maximizing success and career opportunities."
  }
]

  },

  "test-preparation": {
    title: "Test Preparation",
    heroImage: test,
    contentImage: test1,
    description: "Our Test Preparation service offers expert coaching for IELTS, TOEFL, PTE, and other international entrance exams. We provide structured training, mock exams, personalized learning plans, and performance evaluation to help students achieve competitive scores and strengthen their admission prospects.",
    points: [
  {
    title: "Exam Skill Assessment",
    desc: "We evaluate English proficiency and exam readiness for IELTS, TOEFL, and PTE."
  },
  {
    title: "Structured Coaching Program",
    desc: "Expert-led training modules covering all exam sections."
  },
  {
    title: "Mock Tests & Performance Tracking",
    desc: "Real-exam simulations to measure progress and improve accuracy."
  },
  {
    title: "Personalized Improvement Plan",
    desc: "Targeted strategies to strengthen weak areas and boost scores."
  },
  {
    title: "High-Score Achievement Strategy",
    desc: "Advanced exam techniques to maximize score and university eligibility."
  }
]

  },

  "application-assistance": {
    title: "Application Assistance",
    heroImage: appli,
    contentImage: appli1,
    description: "Our Application Assistance service ensures accurate, professional, and timely submission of university applications. We guide students through documentation, SOP writing, LOR preparation, form submissions, and compliance requirements to maximize acceptance success.",
    points: [
  {
    title: "Document & Profile Review",
    desc: "Comprehensive evaluation of academic records and application documents."
  },
  {
    title: "SOP & LOR Development",
    desc: "Professional assistance in writing strong Statements of Purpose and Recommendations."
  },
  {
    title: "University Application Filing",
    desc: "Accurate and timely submission of university applications."
  },
  {
    title: "Deadline & Compliance Monitoring",
    desc: "Tracking application deadlines and institutional requirements."
  },
  {
    title: "Offer Letter & Acceptance Support",
    desc: "Guidance in offer evaluation and enrollment decision-making."
  }
]

  },

  "financial-assistance": {
    title: "Financial Assistance",
    heroImage: fin,
    contentImage: fin1,
    description: "Our Financial Assistance service helps students plan education funding through scholarships, grants, and education loans. We provide expert guidance on budgeting, financial documentation, sponsor planning, and cost-effective study options abroad.",
    points: [
  {
    title: "Education Cost Planning",
    desc: "Breakdown of tuition fees, living expenses, and total study costs."
  },
  {
    title: "Scholarship & Grant Support",
    desc: "Identification and application guidance for scholarships and funding."
  },
  {
    title: "Education Loan Assistance",
    desc: "Support in securing student loans from trusted financial institutions."
  },
  {
    title: "Sponsor Documentation Guidance",
    desc: "Preparation of financial proof and sponsor documentation."
  },
  {
    title: "Affordable Study Strategy",
    desc: "Optimized budgeting to reduce financial burden while studying abroad."
  }
]

  },

  "visa-guidance": {
    title: "Visa Guidance",
    heroImage: visa,
    contentImage: visa1,
    description: "Our Visa Guidance service provides professional assistance in visa documentation, interview preparation, and application filing. We ensure compliance with embassy requirements, reduce rejection risk, and improve visa approval success rates.",
    points: [
  {
    title: "Visa Eligibility Evaluation",
    desc: "Assessment of visa requirements based on country-specific regulations."
  },
  {
    title: "Visa Documentation Preparation",
    desc: "Accurate preparation of financial, academic, and legal documents."
  },
  {
    title: "Mock Visa Interview Training",
    desc: "Simulated embassy interviews to improve confidence and approval chances."
  },
  {
    title: "Application Submission Support",
    desc: "Error-free visa filing to minimize rejection risks."
  },
  {
    title: "High Visa Approval Strategy",
    desc: "Proven techniques to improve visa acceptance success rates."
  }
]

  },

  "pre-departure-assistance": {
    title: "Pre-Departure Assistance",
    heroImage:  pre,
    contentImage: pre1,
    description: "Our Pre-Departure Assistance service prepares students for travel, accommodation, legal compliance, and cultural adaptation before leaving their home country. We ensure a smooth and confident transition abroad.",
    points: [
  {
    title: "Travel & Flight Planning",
    desc: "Guidance on booking flights and preparing travel itineraries."
  },
  {
    title: "Accommodation & Packing Support",
    desc: "Help with housing arrangements and essential packing checklist."
  },
  {
    title: "Cultural & Lifestyle Training",
    desc: "Orientation on adapting to international student life."
  },
  {
    title: "Legal & Immigration Briefing",
    desc: "Understanding legal requirements and student responsibilities abroad."
  },
  {
    title: "Smooth Overseas Transition",
    desc: "Ensuring confidence and readiness before departure."
  }
]

  },

  "accommodation-assistance": {
    title: "Accommodation Assistance",
    heroImage:  acco,
    contentImage: acco1,
    description: "Our Accommodation Assistance service helps students secure safe, affordable, and comfortable housing near universities. We guide students in choosing verified student residences, private rentals, and campus housing.",
    points: [
  {
    title: "Student Housing Consultation",
    desc: "Guidance on choosing safe and affordable accommodation."
  },
  {
    title: "Verified Housing Recommendations",
    desc: "Access to trusted student residences and rental properties."
  },
  {
    title: "Budget-Friendly Living Options",
    desc: "Affordable housing choices near universities."
  },
  {
    title: "Short-Term & Long-Term Rentals",
    desc: "Flexible housing options to suit student needs."
  },
  {
    title: "Secure & Comfortable Stay Planning",
    desc: "Ensuring safe, comfortable, and student-friendly living."
  }
]

  },

  "post-arrival-assistance": {
    title: "Post-Arrival Assistance",
    heroImage:  post,
    contentImage: post1,
    description: "Our Post-Arrival Assistance service supports students after reaching their study destination. We help with airport pickup, SIM cards, banking setup, local registration, and settlement support to ensure a smooth start abroad.",
    points: [
  {
    title: "Airport Pickup & Settlement Support",
    desc: "Assistance with airport transfers and initial accommodation."
  },
  {
    title: "Local SIM & Banking Setup",
    desc: "Help with SIM cards, bank accounts, and essential services."
  },
  {
    title: "Student Orientation & Guidance",
    desc: "Support in adapting to campus and academic life."
  },
  {
    title: "Emergency & Local Assistance",
    desc: "Ongoing support for student safety and well-being."
  },
  {
    title: "Smooth Integration Abroad",
    desc: "Helping students settle comfortably in a new country."
  }
]

  }
};



/* ================= OTHER SERVICES ================= */

const otherServices = Object.keys(serviceData).map(slug => ({
  slug,
  title: serviceData[slug].title
}));

/* ================= COMPONENT ================= */

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = serviceData[slug];

  const sectionRef = useRef(null);
  const inView = useInView(sectionRef, { once: true, margin: "-120px" });



  if (!service) return <p className="text-center mt-40">Service not found</p>;

  return (
    <section className="bg-white">

      {/* ================= HERO ================= */}
     <div className="relative h-[300px] md:h-[420px] overflow-hidden">

  {/* Background Image */}
  <motion.img
    src={service.heroImage}
    initial={{ scale: 1.12, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ duration: 1.4 }}
    className="absolute inset-0 w-full h-full object-cover object-[center_10%]"
  />

  {/* DARK OVERLAY (KEY FIX) */}
  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20" />

  {/* TITLE */}
  <div className="relative max-w-7xl mx-auto px-6 h-full flex items-end pb-10">
    <motion.h1
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.1 }}
      className="text-white text-4xl md:text-6xl font-extrabold tracking-tight"
    >
      {service.title}
    </motion.h1>
  </div>

</div>


      {/* ================= MAIN SECTION ================= */}
      <div ref={sectionRef} className="py-24">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[260px_1fr] gap-16">

          {/* SIDEBAR — ALTERNATING BACKGROUND */}
          <motion.aside
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="space-y-4"
          >
            <h3 className="text-lg font-bold text-[#1A358A] mb-4">
              Other Services
            </h3>

            {otherServices.map((item, i) => {
              const isBlue = i % 2 === 0;
              return (
                <Link key={item.slug} to={`/services/${item.slug}`}>
                  <motion.div
                    whileHover={{ x: 6 }}
                    className={`px-4 py-3 rounded-lg border transition font-medium ${
                      item.slug === slug
                        ? "border-[#1A358A] font-semibold"
                        : "border-[#1A358A]/20"
                    } ${isBlue ? "bg-gradient-to-r from-[#1A358A] to-[#2449B6] text-white" : "bg-white hover:bg-[#F4F7FF]"}`}
                  >
                    {item.title}
                  </motion.div>
                </Link>
              );
            })}
          </motion.aside>

          {/* CONTENT */}
          <div className="space-y-16">

            {/* IMAGE BIG */}
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 1 }}
              className="rounded-3xl overflow-hidden shadow-2xl"
            >
              <img
                src={service.contentImage}
                className="w-full h-[340px] md:h-[520px] object-cover"
                alt=""
              />
            </motion.div>
          {/*TITLE*/}
         <motion.h2
  initial={{ opacity: 0, y: 30 }}
  animate={inView ? { opacity: 1, y: 0 } : {}}
  transition={{ duration: 0.8 }}
  className="text-3xl md:text-4xl xl:text-5xl font-extrabold text-[#1A358A] 
             lg:-ml-[260px] xl:-ml-[320px] 2xl:-ml-[360px]"
>
  About {service.title}
</motion.h2>





<motion.div
  initial={{ opacity: 0, y: 20 }}
  animate={inView ? { opacity: 1, y: 0 } : {}}
  transition={{ duration: 0.9 }}
  className="text-gray-700 text-lg leading-relaxed space-y-5 
             lg:-ml-[260px] xl:-ml-[320px] 2xl:-ml-[360px] 
             lg:w-[125%] xl:w-[140%] 2xl:w-[150%]"
>
  <p>{service.description}</p>
  <p>We apply a structured, data-driven advisory model to guide students toward the most suitable academic and career opportunities abroad.</p>
  <p>Our consultants provide personalized recommendations based on profile evaluation, financial planning, and future employability.</p>
  <p>Every student receives tailored guidance supported by institutional research, compliance checks, and admissions strategy planning.</p>
  <p>Our goal is to deliver a seamless, high-success overseas education experience built on transparency and expertise.</p>
</motion.div>





          </div>
        </div>
      </div>

      {/* ================= HOW IT WORKS — TIMELINE ================= */}
      <div className="py-24 bg-gradient-to-r from-[#1A358A] to-[#2449B6] text-white">
        <div className="max-w-7xl mx-auto px-6">

          <motion.h3
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="text-3xl font-bold mb-12 text-center"
          >
            How this  {service.title} Works
          </motion.h3>

          <div className="grid md:grid-cols-3 gap-10">
  {service.points.map((step, i) => (
    <motion.div
      key={i}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: i * 0.12 }}
      className="bg-white/10 backdrop-blur-lg p-8 rounded-2xl border border-white/20"
    >
      <span className="text-sm opacity-80">Step {i + 1}</span>

      <h4 className="text-lg font-semibold mt-2">
        {step.title}
      </h4>

      <p className="text-white/80 text-sm mt-2">
        {step.desc}
      </p>
    </motion.div>
  ))}
</div>


        </div>
      </div>

      
{/* ================= REAL IMPACT — STATS ================= */}
<div className="py-24 bg-[#F9FBFF]">
  <div className="max-w-7xl mx-auto px-6 text-center">

    <motion.h3
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      className="text-3xl md:text-4xl font-bold text-[#1A358A]"
    >
      Real Impact & Measurable Outcomes
    </motion.h3>

    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      className="mt-4 max-w-3xl mx-auto text-gray-600 text-lg"
    >
      Our service delivers tangible academic, financial, and career success outcomes for international students.
    </motion.p>

    <div className="grid md:grid-cols-4 gap-12 mt-16">
      {[
        { number: "95%", label: "Success Rate" },
        { number: "10K+", label: "Students Guided" },
        { number: "450+", label: "Partner Universities" },
        { number: "18+", label: "Years of Experience" }
      ].map((stat, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.12 }}
          className="space-y-2"
        >
          <h4 className="text-4xl font-extrabold text-[#1A358A]">
            {stat.number}
          </h4>
          <p className="text-gray-600 text-sm tracking-wide uppercase">
            {stat.label}
          </p>
        </motion.div>
      ))}
    </div>

  </div>
</div>


  
      {/* ================= CTA ================= 
      <div className="py-24 text-center bg-gradient-to-r from-[#1A358A] to-[#2449B6]">
        <motion.h3
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-3xl font-bold text-white"
        >
          Why Students Choose This Service
        </motion.h3>

        <p className="mt-4 max-w-2xl mx-auto text-white">
         Our service provides measurable results, strategic planning, and high success outcomes for international students.
        </p>

        <motion.button
          whileHover={{ scale: 1.05 }}
          className="mt-8 px-12 py-3 bg-[#1A358A] text-white font-semibold rounded-full shadow-lg"
        >
          Book a Consultation
        </motion.button>
      </div>*/}
      {/* ================= SERVICE IMPACT — CARDS ================= 
<div className="py-24 bg-white">
  <div className="max-w-7xl mx-auto px-6">

    <motion.h3
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      className="text-2xl font-bold text-[#1A358A] mb-12 text-center"
    >
      Key Benefits of This Service
    </motion.h3>

    <div className="grid md:grid-cols-3 gap-10">
      {service.points.map((item, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.12 }}
          whileHover={{ y: -8, scale: 1.02 }}
          className="bg-[#F7F9FF] p-8 rounded-2xl shadow-xl border border-[#1A358A]/10"
        >
          <h4 className="text-lg font-bold text-[#1A358A] mb-3">
            {item}
          </h4>
          <p className="text-gray-600 text-sm leading-relaxed">
            A high-impact benefit designed to maximize success rate, reduce risks, and improve long-term international education outcomes.
          </p>
        </motion.div>
      ))}
    </div>

  </div>
</div>*/}


    </section>
  );
}
